module.exports = __webpack_public_path__ + "assets/img/mecha-btn-71459a67.png";